
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8279_16954)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"15","height":"14"}},[_c('path',{attrs:{"d":"M.52 0h14v14h-14V0z","fill":"#fff"}})]),_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#383838","mask":"url(#a)"}},[_c('path',{attrs:{"d":"M11.96.994a.5.5 0 00-.355.148l-.002.002L5.987 6.74l-.359 2.182 2.149-.386 5.599-5.619.002-.002a.5.5 0 000-.71l-.002-.002-1.061-1.061a.5.5 0 00-.355-.148zM11.383.11a1.5 1.5 0 011.641.327h.001l1.057 1.058h.001a1.5 1.5 0 010 2.129L8.373 9.354a.5.5 0 01-.265.139l-3 .54a.5.5 0 01-.582-.573l.5-3.04a.5.5 0 01.14-.273l5.73-5.71a1.5 1.5 0 01.486-.326z"}}),_c('path',{attrs:{"d":"M2.02 2.5a.5.5 0 00-.5.5v9.5a.5.5 0 00.5.5h9.5a.5.5 0 00.5-.5v-3a.5.5 0 111 0v3a1.5 1.5 0 01-1.5 1.5h-9.5a1.5 1.5 0 01-1.5-1.5V3a1.5 1.5 0 011.5-1.5h3a.5.5 0 010 1h-3z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8279_16954"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15v14H0z"}})])])])
          )
        }
      }
    